module.exports = __webpack_public_path__ + "teqbahn-assets/media/Slide4.2c73814e.gif";